<template>
    <div class="element" @click="selectElement(id, name, imgSrc, description, default_minimum_material_density, default_minimum_material_density_value, delta_t_condition_check)"
         :data-is-expanded="false"
         :class="{emptyClass : isSelected}"
         :ref="name">
    <!-- :class="{selected: isSelected}"-->

        <div class="img-container">
            <img class="imgStatic" :src="'data:image/png;base64, ' + imgSrc" alt="fan"/>
            <img class="imgHover" :src="'data:image/png;base64, ' + imgClicked" alt="fan_transparent"/>
        </div>
        <div class="name-container">
            <span class="text">{{translate(name)}}</span>
        </div>

        <div class="expandable_text-container"
             :class="{hidden : isExpanded}"
             :ref="name + '-desc'">
            <span class="text">{{translate(description)}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FirstStepElement",
        props: ['id','name', 'imgSrc', 'description','default_minimum_material_density', 'default_minimum_material_density_value', 'imgClicked', 'delta_t_condition_check'],
        data() {
            return {
                isExpanded: false,
                // btnHeight: 0,
            }
        },
        methods: {
            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },

            changeStep(step) {

                this.$store.commit({
                    type: 'changeActiveConfigurationStep',
                    step: step
                });

            },

            selectElement(id, name, imgSrc, description, default_minimum_material_density, default_minimum_material_density_value, delta_t_condition_check) {

                this.$store.commit({
                    type: 'selectFirstStepElement',
                    id: id,
                    name: name,
                    imgSrc: imgSrc,
                    description: description,
                    default_minimum_material_density: default_minimum_material_density,
                    default_minimum_material_density_value: default_minimum_material_density_value,
                    delta_t_condition_check: delta_t_condition_check,
                });

                this.changeStep(2);
            },

            unselectElement(){
                this.$store.commit({
                    type: 'selectFirstStepElement',
                    id: '',
                    name: '',
                    imgSrc: '',
                    description: '',
                    default_minimum_material_density: 0,
                    default_minimum_material_density_value: 0,
                    delta_t_condition_check: 0,
                });
            },
        },

        computed: {

            getActiveId() {
                return this.$store.state.selectedFirstStepElement.id;
            },

            isSelected() {
                return this.getActiveId === this.id;
            }
        },
    }
</script>